// Maps a free-form class category ("Fire", "EMS - Basic", "AHA BLS") to a beacon category token.
const RULES = [
  [/fire/i, "firefighter"],
  [/\b(ems|emt)\b|paramedic|medical/i, "ems"],
  [/aha|bls|acls|pals|cpr/i, "aha"],
  [/rescue/i, "rescue"],
  [/police|law/i, "police"],
  [/lifeguard|aquatic/i, "lifeguard"],
  [/security/i, "security"],
  [/tactical/i, "tactical"],
  [/admin/i, "admin"],
];

export function categoryColor(category) {
  const hit = RULES.find(([re]) => re.test(category || ""));
  return `var(--color-cat-${hit ? hit[1] : "other"})`;
}
